/// <reference path="../system/jquery-1.11.3.min.js" />
/// <reference path="Helper.Url.js" />

class HelperString {
	static defaultLanguage = null;
	static fetchedStrings = {};

	/**
	 * @param base64Data {string}
	 * @param contentType {?string}
	 * @returns {Blob}
	 */
	static base64toBlob(base64Data, contentType = null) {
		contentType = contentType || "";
		const sliceSize = 1024;
		const byteCharacters = atob(encodeURI(base64Data));
		const bytesLength = byteCharacters.length;
		const slicesCount = Math.ceil(bytesLength / sliceSize);
		const byteArrays = new Array(slicesCount);

		for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			const begin = sliceIndex * sliceSize;
			const end = Math.min(begin + sliceSize, bytesLength);

			const bytes = new Array(end - begin);
			for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, {type: contentType});
	}

	/**
	 * @param alienString {string}
	 * @param defaultstring {?string}
	 * @param language {?string}
	 * @returns {string|null}
	 */
	static getTranslatedString(alienString, defaultstring = null, language = null) {
		if (!alienString) {
			return defaultstring;
		}
		language = language || HelperString.defaultLanguage;
		const fetched = !!language && !!HelperString.fetchedStrings[language] ? HelperString.fetchedStrings[language][alienString] : HelperString.fetchedStrings[alienString];
		if (!!fetched) {
			return fetched;
		}
		const containsSpecialChars = /[^A-Za-z0-9_\.]/.exec(alienString) != null;
		const selectors = [`${alienString}.translation`, `${alienString}-translation`];
		if (alienString.indexOf(".") !== -1){
			selectors.push(alienString.replace(".", "_") + ".translation", alienString.replace(".", "_") + "-translation");
		}
		const current = !containsSpecialChars ? $(selectors.map(selector => document.getElementById(selector)).filter(x => x !== null)) : [];
		if (current?.length > 0) {
			return current.text();
		} else if (!!defaultstring) {
			return defaultstring;
		} else {
			return `Translation Missing: "${alienString}"`;
		}
	}


	/**
	 * @param format {string}
	 * @param params {*}
	 * @returns {string}
	 */
	static format(format, params) {
		return format.replace(/{([0-9]+)}/g, function (_, i) {
			return params[i];
		});
	}

	/**
	 * @param alienString {string}
	 * @param language {?string}
	 * @returns {Promise<string>}
	 */
	static fetchStringTranslation(alienString, language = null) {
		const deferred = new $.Deferred();
		if (!!(HelperString.fetchedStrings)[alienString]) {
			deferred.resolve((HelperString.fetchedStrings)[alienString]);
		} else {
			let url = Helper.Url.resolveUrl("~/Resource/" + alienString + ".json");
			if (!!language) {
				url += "?language=" + language;
			}
			$.ajax(url,
				{
					cache: true,
					success: function (data) {
						HelperString.fetchedStrings[alienString] = data.Value;
						deferred.resolve(data.Value);
					}
				});
		}
		return deferred.promise();
	}

	/**
	 * @param alienString {string}
	 * @param language {?string}
	 * @returns {Promise<string>}
	 */
	static fetchStringTranslationPromise(alienString, language = null) {
		return new Promise(resolve => {
			if (!!HelperString.fetchedStrings[alienString]) {
				resolve(HelperString.fetchedStrings[alienString]);
			} else {
				let url = HelperUrl.resolveUrl(`~/Resource/${alienString}.json`);
				if (!!language) {
					url += "?language=" + language;
				}
				fetch(url, {cache: "force-cache"})
					.then(value => value.json())
					.then(value => {
						HelperString.fetchedStrings[alienString] = value;
						resolve(value);
					})
			}

		})
	}

	/**
	 * @param language {string}
	 */
	static setDefaultLanguage(language) {
		HelperString.defaultLanguage = language;
	}

	/**
	 * @param resourceKey {string}
	 * @param translation {string}
	 * @param language {?string}
	 */
	static setStringTranslation(resourceKey, translation, language = null) {
		if (!!language) {
			HelperString.fetchedStrings[language] = HelperString.fetchedStrings[language] || {};
			HelperString.fetchedStrings[language][resourceKey] = translation;
		} else {
			HelperString.fetchedStrings[resourceKey] = translation;
		}
	}

	/**
	 * @param longString {string}
	 * @param maxLength {number}
	 * @returns {string}
	 */
	static limitStringWithEllipses(longString, maxLength = 9) {
		if (longString.length > maxLength && maxLength > 0) {
			return longString.substr(0, maxLength - 4) + "...";
		} else {
			return longString;
		}
	}

	/**
	 * @param unsafeText
	 * @returns {string}
	 */
	static htmlEntities(unsafeText) {
		unsafeText = unsafeText.toString();
		if (!unsafeText) return "";
		const temporaryDiv = $("<div></div>").addClass("hide").appendTo("body").text(unsafeText);
		const safeText = temporaryDiv.html();
		temporaryDiv.remove();
		return safeText;
	}

	/**
	 * @param str {string}
	 * @returns {number}
	 */
	static hash(str) {
		let hash = 0;
		let i;
		let chr;
		let len;
		if (!str || str.length === 0) return hash;
		for (i = 0, len = str.length; i < len; i++) {
			chr = str.charCodeAt(i);
			hash = ((hash << 5) - hash) + chr;
			hash |= 0;
		}
		return hash;
	}

	/**
	 * @param str {string}
	 * @returns {boolean}
	 */
	static isGuid(str) {
		return /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi.test(str);
	}

	/**
	 * @returns {"00000000-0000-0000-0000-000000000000"}
	 */
	static emptyGuid() {
		return "00000000-0000-0000-0000-000000000000";
	}

	/**
	 * @param x
	 * @returns {string}
	 */
	static trim(x) {
		return (window.ko.unwrap(x) || "").trim();
	}

	/**
	 * @param html {string}
	 * @returns {string}
	 */
	static replaceLineBreaks(html) {
		return html.replace(/\\r\\n|\\r|\\n/g, "<br>");
	}

	/**
	 * @param errorMessage {{value: string}|string}
	 * @returns {?string}
	 */
	static tryExtractErrorMessageValue(errorMessage) {
		try {
			const parsedError = typeof errorMessage === 'object' ? errorMessage : JSON.parse(errorMessage);
			if (parsedError && parsedError.value) {
				return parsedError.value;
			}
		} catch { }

		return null;
	}
}


(window.Helper = window.Helper || {}).String = HelperString;